import type { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { SpinnerService } from "./spinner.service";
import { SKIP_SPINNER } from "./skip-spinner.context";
import { finalize } from "rxjs";

export const spinnerInterceptor: HttpInterceptorFn = (req, next) => {
    const spinnerService = inject(SpinnerService);

    if (req.context.get(SKIP_SPINNER) || ignoreList.some((x) => req.url.includes(x))) {
        return next(req);
    }

    spinnerService.addRequest();

    return next(req).pipe(finalize(() => spinnerService.removeRequest()));
};

const ignoreList = ["/analytics", "/surveys/send"];
